/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PresenceViewer
 */
export interface PresenceViewer {
  /**
   *
   * @type {string}
   * @memberof PresenceViewer
   */
  adminEmail: string;
  /**
   *
   * @type {string}
   * @memberof PresenceViewer
   */
  fieldFocus?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof PresenceViewer
   */
  lastSeenAt: OffsetDateTime;
  /**
   *
   * @type {boolean}
   * @memberof PresenceViewer
   */
  foregroundTab: boolean;
}

/**
 * Check if a given object implements the PresenceViewer interface.
 */
export function instanceOfPresenceViewer(
  value: object,
): value is PresenceViewer {
  if (!("adminEmail" in value) || value["adminEmail"] === undefined)
    return false;
  if (!("lastSeenAt" in value) || value["lastSeenAt"] === undefined)
    return false;
  if (!("foregroundTab" in value) || value["foregroundTab"] === undefined)
    return false;
  return true;
}

export function PresenceViewerFromJSON(json: any): PresenceViewer {
  return PresenceViewerFromJSONTyped(json, false);
}

export function PresenceViewerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PresenceViewer {
  if (json == null) {
    return json;
  }
  return {
    adminEmail: json["adminEmail"],
    fieldFocus: json["fieldFocus"] == null ? undefined : json["fieldFocus"],
    lastSeenAt: json["lastSeenAt"],
    foregroundTab: json["foregroundTab"],
  };
}

export function PresenceViewerToJSON(json: any): PresenceViewer {
  return PresenceViewerToJSONTyped(json, false);
}

export function PresenceViewerToJSONTyped(
  value?: PresenceViewer | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    adminEmail: value["adminEmail"],
    fieldFocus: value["fieldFocus"],
    lastSeenAt: value["lastSeenAt"],
    foregroundTab: value["foregroundTab"],
  };
}
